import React from 'react';

import styles from './qAndAStyles';

const { profileQuestions } = require('buyside/util/constantsFromRails.json');

const Expertise = ({ userProfile }) => {
  const { profileAnswers } = userProfile;
  return (
    <div>
      <ul className={styles.qAndAList}>
        {profileAnswers.map((profileAnswer, idx) => (
          <li key={idx}>
            <h4>{profileQuestions[idx].question}</h4>
            <span>{profileAnswer.answer}</span>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default Expertise;
